import React from "react";
import { StyledPagination, StyledTablePagination } from "../StyledComponents/styled";
import { Box, Stack } from "@mui/material";

const NumberedModalPagination = ({
  totalCount,
  defaultSelectedPage,
  changeCall,
  rowSizeChangeCall,
  rowSize,
  totalRecordCount,
  boxWidth
}) => {
  const handleChangeRowsPerPage = (event) => {
    rowSizeChangeCall(parseInt(event.target.value, 10));
  };

  return (
    <Box 
      display="grid"
      gridTemplateColumns="1fr auto 1fr"
      alignItems="center" 
      width={typeof boxWidth !== "undefined" ? boxWidth : "100%"}
      mt={1}
    >
      {/* --------- Left: Total records info --------- */}
      <Box justifySelf="start">
        <StyledTablePagination
          sx={{ paddingLeft: "0px" }}
          rowsPerPageOptions={[]}
          component="div"
          count={totalRecordCount}
          page={parseInt(defaultSelectedPage - 1)}
          onPageChange={() => {}}
          rowsPerPage={rowSize}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={() => null}
          labelDisplayedRows={({ from, to, count }) => `Showing ${from} - ${to} of ${count}`}
        />
      </Box>

      {/* --------- Center: Page navigation + row size --------- */}
      <Box justifySelf="center">
        <Stack direction="row" spacing={2} alignItems="center">
          <StyledPagination
            count={totalCount}
            onChange={changeCall}
            variant="text"
            page={defaultSelectedPage}
            siblingCount={2}
            sx={{ marginTop: "0px !important" }}
          />

          <StyledTablePagination
            rowsPerPageOptions={[10, 20, 50, 100]}
            component="div"
            count={totalRecordCount}
            page={defaultSelectedPage - 1}
            onPageChange={() => {}}
            rowsPerPage={rowSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={() => null}
            labelDisplayedRows={() => null}
          />
        </Stack>
      </Box>

      {/* --------- Right: Empty spacer for balance --------- */}
      <Box />
    </Box>
  );
};

export default NumberedModalPagination;